exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert {\n  margin-left: 5px;\n  vertical-align: middle;\n}\n.attendingPhysicianName {\n  color: #000000;\n  font-family: \"Lato\";\n  font-size: 16px;\n  font-style: italic;\n  font-weight: 700;\n  margin-right: 5px;\n  overflow-wrap: break-word !important;\n}\n.clientText {\n  color: #333333;\n  font-family: \"Lato\";\n  font-size: 14px;\n  font-weight: 700;\n  margin-right: 15px;\n  overflow-wrap: break-word !important;\n  vertical-align: middle;\n}\n", ""]);

// exports
